import { helper } from '@ember/component/helper';

/**
 * Verifica se un elemento è contenuto in una collezione Ember
 * @param {Object} item - Elemento Ember con metodo get
 * @param {Array} collection - Collezione di elementi Ember
 * @returns {boolean}
 */
function collectionContain([item, collection]) {
  // == null: un id valido può essere 0 (che !item?.id scarterebbe)
  if (!Array.isArray(collection) || item?.id == null) return false;
  const {
    id: itemId
  } = item;
  return collection.some(entry => entry?.get?.('id') === itemId);
}
var collectionContain$1 = helper(collectionContain);

export { collectionContain, collectionContain$1 as default };
//# sourceMappingURL=collection-contain.js.map
